import React, { useState } from 'react';
import styles from './Gallery.module.css';

// Импортируем изображения
import image1 from '../../assets/images/mod-4ek-01.jpg';
import image2 from '../../assets/images/mod-4ek-02.jpg';
import image3 from '../../assets/images/mod-4ek-03.jpg';
import image4 from '../../assets/images/mod-4ek-04.jpg';
import image5 from '../../assets/images/mod-4ek-05.jpg';
import image6 from '../../assets/images/mod-4ek-06.jpg';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { id: 1, src: image1, alt: 'Кассовый чек гостиницы Москва', title: 'Гостиничный чек' },
    { id: 2, src: image2, alt: 'Чек строительных материалов', title: 'Строительные материалы' },
    { id: 3, src: image3, alt: 'Товарный чек электроники', title: 'Электроника и техника' },
    { id: 4, src: image4, alt: 'Чек ресторана', title: 'Рестораны и кафе' },
    { id: 5, src: image5, alt: 'Акт выполненных работ', title: 'Акты и УПД' },
    { id: 6, src: image6, alt: 'Счет-фактура', title: 'Счет-фактуры' },
  ];

  const openModal = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <section id="gallery" className={`section ${styles.gallery}`}>
      <div className="container">
        <div className={styles.galleryHeader}>
          <h2 className="section-title">
            ПРИМЕРЫ <span className="section-title--accent">ДОКУМЕНТОВ</span>
          </h2>
          <p className="section-subtitle">
            Примеры реальных документов, изготовленных нами. Все чеки имеют QR-код ФНС
          </p>
        </div>

        <div className={styles.galleryGrid}>
          {images.map((image) => (
            <div 
              key={image.id} 
              className={`card ${styles.galleryItem}`}
              onClick={() => openModal(image)}
            >
              <div className={styles.imageContainer}>
                <img 
                  src={image.src} 
                  alt={image.alt} 
                  className={styles.galleryImage}
                  loading="lazy"
                />
                <div className={styles.imageOverlay}>
                  <div className={styles.overlayContent}>
                    <i className="fas fa-search-plus"></i>
                    <span className={styles.overlayText}>Просмотр</span>
                  </div>
                </div>
              </div>
              {/* <div className={styles.imageCaption}>
                <h3 className={styles.imageTitle}>{image.title}</h3>
                <span className={styles.imageBadge}>QR-код ФНС</span>
              </div> */}
            </div>
          ))}
        </div>

        <div className={styles.galleryInfo}>
          <div className={styles.infoCard}>
            <div className={styles.infoIcon}>
              <i className="fas fa-qrcode"></i>
            </div>
            <div className={styles.infoContent}>
              <h3 className={styles.infoTitle}>Проверка через ФНС</h3>
              <p className={styles.infoText}>
                Все чеки имеют QR-код для проверки на сайте ФНС. 
                Гарантируем 100% прохождение любой проверки.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Модальное окно для просмотра изображения */}
      {selectedImage && (
        <div className={styles.modal} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.modalClose} onClick={closeModal}>
              <i className="fas fa-times"></i>
            </button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt} 
              className={styles.modalImage}
            />
            {/* <div className={styles.modalInfo}>
              <h3 className={styles.modalTitle}>{selectedImage.title}</h3>
              <p className={styles.modalDescription}>{selectedImage.alt}</p>
            </div> */}
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;